import { createRelayResource } from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import UI_ORGANIZATION_DETAILS_PAGE_QUERY, {
	type OrganizationDetailsPageQuery,
} from '@atlassian/jira-servicedesk-organization-details/src/ui/__generated__/OrganizationDetailsPageQuery.graphql';

const getCustomerServiceOrganizationAri = (
	organizationId: string,
	activationId: string,
): string => {
	return `ari:cloud:jira-servicedesk::organization/activation/${activationId}/${organizationId}`;
};

export const OrganizationDetailsPageQueryResource =
	createRelayResource<OrganizationDetailsPageQuery>({
		type: 'UI_ORGANIZATION_DETAILS_PAGE_QUERY',
		getQuery: ({ match }, { tenantContext }) => ({
			parameters: UI_ORGANIZATION_DETAILS_PAGE_QUERY,
			variables: {
				organizationId: getCustomerServiceOrganizationAri(
					String(match.params.organizationId),
					tenantContext.activationId,
				),
				cloudId: tenantContext.cloudId,
			},
			options: { fetchPolicy: 'store-and-network' },
		}),
	});
